var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAvaScheduler(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 117.1 119.48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m107.37,10.06h-.33s-10.69,0-10.69,0v7.67c0,6.67-5.41,12.07-12.07,12.08h-2.14c-6.67,0-12.07-5.41-12.07-12.08v-7.67h-22.77v7.67c0,6.67-5.41,12.07-12.08,12.08h-2.26c-6.67,0-12.07-5.41-12.08-12.08v-7.67h-10.69C4.6,10.04.05,14.54,0,20.13v83.14c-.14,8.75,6.79,15.98,15.54,16.22,0,0,0,0,0,0h86.02c8.74-.24,15.67-7.46,15.54-16.2V20.25c.12-5.5-4.23-10.06-9.73-10.19Zm-10.52,94.08H20.37c-2.78,0-5.02-2.26-5.03-5.03v-44.53c-.04-2.74,2.16-4.99,4.9-5.03h76.48c2.78,0,5.02,2.26,5.03,5.03v44.53h.13c0,2.78-2.26,5.02-5.03,5.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m34.71,0h-1.13c-3.54.01-6.4,2.88-6.42,6.42v11.32c-.09,3.18,2.41,5.82,5.59,5.91h.33s2.14,0,2.14,0c3.26,0,5.9-2.63,5.91-5.89h0V6.42c-.01-3.54-2.88-6.4-6.42-6.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m83.64,0h-1.13c-3.54.02-6.4,2.88-6.41,6.42v11.32c0,3.26,2.64,5.91,5.9,5.91h0s2.14,0,2.14,0c3.26,0,5.91-2.63,5.91-5.89h0V6.42c-.02-3.54-2.88-6.4-6.41-6.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30.33,66.56h6.49c1.31.03,2.4-1.01,2.42-2.32.03-1.31-1.01-2.4-2.32-2.42h-6.49c-1.31-.03-2.4,1.01-2.42,2.32-.03,1.31,1.01,2.4,2.32,2.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m55.25,66.56h6.49c1.31.03,2.4-1.01,2.42-2.32s-1.01-2.4-2.32-2.42h-6.49c-1.31-.03-2.4,1.01-2.42,2.32-.03,1.31,1.01,2.4,2.32,2.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m80.17,66.56h6.49c1.31.03,2.4-1.01,2.42-2.32.03-1.31-1.01-2.4-2.32-2.42h-6.49c-1.31-.03-2.4,1.01-2.42,2.32s1.01,2.4,2.32,2.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30.33,79.64h6.49c1.31.03,2.4-1.01,2.42-2.32.03-1.31-1.01-2.4-2.32-2.42h-6.49c-1.31-.03-2.4,1.01-2.42,2.32-.03,1.31,1.01,2.4,2.32,2.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m55.25,79.64h6.49c1.31.03,2.4-1.01,2.42-2.32s-1.01-2.4-2.32-2.42h-6.49c-1.31-.03-2.4,1.01-2.42,2.32-.03,1.31,1.01,2.4,2.32,2.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m80.17,79.64h6.49c1.31.03,2.4-1.01,2.42-2.32.03-1.31-1.01-2.4-2.32-2.42h-6.49c-1.31-.03-2.4,1.01-2.42,2.32s1.01,2.4,2.32,2.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m36.92,87.98h-6.49c-1.31-.03-2.4,1.01-2.42,2.32-.03,1.31,1.01,2.4,2.32,2.42h6.49c1.31.03,2.4-1.01,2.42-2.32s-1.01-2.4-2.32-2.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m61.84,87.98h-6.49c-1.31-.03-2.4,1.01-2.42,2.32-.03,1.31,1.01,2.4,2.32,2.42h6.49c1.31.03,2.4-1.01,2.42-2.32s-1.01-2.4-2.32-2.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m86.75,87.98h-6.49c-1.31-.03-2.4,1.01-2.42,2.32s1.01,2.4,2.32,2.42h6.49c1.31.03,2.4-1.01,2.42-2.32.03-1.31-1.01-2.4-2.32-2.42Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvaScheduler);
export default __webpack_public_path__ + "static/media/AVA-Scheduler.ae5dcf8e0fbf2b15fa40395ac27d4235.svg";
export { ForwardRef as ReactComponent };